// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-viewer-viewer__viewer {\n  isolation: isolate;\n}\n\n.src-viewer-viewer__content {\n  isolation: isolate;\n  z-index: 0;\n}\n\n.src-viewer-viewer__widget {\n  isolation: isolate;\n  z-index: 1;\n}\n", "",{"version":3,"sources":["webpack://./src/viewer/viewer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":[".viewer {\n  isolation: isolate;\n}\n\n.content {\n  isolation: isolate;\n  z-index: 0;\n}\n\n.widget {\n  isolation: isolate;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewer": "src-viewer-viewer__viewer",
	"content": "src-viewer-viewer__content",
	"widget": "src-viewer-viewer__widget"
};
export default ___CSS_LOADER_EXPORT___;
